(() => {
  const roots = document.querySelectorAll('[data-countdown]');

  roots.forEach((root) => {
    const target = Date.parse(root.dataset.launchDate);
    if (Number.isNaN(target)) return;

    const fields = {
      days: root.querySelector('[data-days]'),
      hours: root.querySelector('[data-hours]'),
      minutes: root.querySelector('[data-minutes]'),
      seconds: root.querySelector('[data-seconds]')
    };

    let timer;

    const render = () => {
      const remaining = Math.max(0, target - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60
      };

      Object.entries(values).forEach(([key, value]) => {
        if (fields[key]) fields[key].textContent = String(value).padStart(2, '0');
      });

      if (remaining === 0 && timer) window.clearInterval(timer);
    };

    render();
    if (target > Date.now()) timer = window.setInterval(render, 1000);
  });
})();
